angular
	.module 'App.Repository'

.factory 'IntegrationRepository', ['BaseRepository', (BaseRepository) ->
	class IntegrationRepository extends BaseRepository
		@resource = '/integrations'
		@isRestricted = true

		getConfiguration: (apiIntegration) ->
			@findById "#{apiIntegration}/configuration"

		getConfigurationOptions: (apiIntegration) ->
			@findById "#{apiIntegration}/configuration_options"

		saveConfiguration: (apiIntegration, model, isUpdate, withAttachments) ->
			url = "/#{apiIntegration}/configuration"

			if !isUpdate
				method = 'POST'
			else
				method = 'PUT'

			if withAttachments
				config = @getConfigForRequestWithAttachment()
			else
				config = @createConfig(null)

			return @request(method, @getUrl(url), model, config)

		run: (apiIntegration, data = [], action = 'run') ->
			@post "#{apiIntegration}/#{action}", data

		createExport: (apiIntegration, from, to) ->
			@post "#{apiIntegration}/export", {from: from, to: to}

		createFiskalyAtExport: (apiIntegration, cashRegisterId, from, to) ->
			@post "#{apiIntegration}/export", {cash_register_id: cashRegisterId, start_time_signature: from, end_time_signature: to}

		createFiskalyEsExport: (apiIntegration, shopId, from, to) ->
			@post "#{apiIntegration}/export", {shop_id: shopId, from: from, to: to}

		createFiskalyDeExport: (apiIntegration, clientId, from, to) ->
			@post "#{apiIntegration}/export", {client_id: clientId, start_date: from, end_date: to}

		getExportStatus: (apiIntegration, id) ->
			@findById "#{apiIntegration}/export/#{id}"

		getExportDownloadUrl: (apiIntegration, id) ->
			@toString null, "/#{apiIntegration}/export/#{id}/download"

		getFailedTransfers: (apiIntegration) ->
			@findById "#{apiIntegration}/failed_transfers"

		customPost: (apiIntegration, action, data) ->
			@post "#{apiIntegration}/#{action}", data

		retry: (data) ->
			@post 'retry', data

	new IntegrationRepository
]
